// extracted by mini-css-extract-plugin
export default {"bm-map":"bm-map","mapboxgl-ctrl-attrib":"mapboxgl-ctrl-attrib"};